import React, { useEffect, useState } from "react";
import api, { BOOK_CATEGORIES } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Layout";
import { BookCard } from "@/components/BookCard";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function Library() {
  const [books, setBooks] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("सभी");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/books").then((res) => setBooks(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = books.filter((b) => {
    const matchQ = !q || b.title.includes(q) || (b.author || "").includes(q) || (b.description || "").includes(q);
    const matchC = cat === "सभी" || b.category === cat;
    return matchQ && matchC;
  });

  return (
    <div>
      <PageHeader testId="library-header" title="डिजिटल पुस्तकालय" subtitle="फाउंडेशन द्वारा प्रकाशित एवं संग्रहित पुस्तकें — पढ़ें एवं डाउनलोड करें" />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-4 mb-8">
          <div className="relative flex-1">
            <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <Input data-testid="library-search-input" value={q} onChange={(e) => setQ(e.target.value)}
              placeholder="पुस्तक, लेखक या विषय खोजें..." className="pl-10 h-11 bg-white border-amber-200" />
          </div>
          <div className="flex gap-2 flex-wrap">
            {["सभी", ...BOOK_CATEGORIES].map((c) => (
              <button key={c} data-testid={`library-cat-${c}`} onClick={() => setCat(c)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  cat === c ? "bg-[#0a2540] text-white" : "bg-white border border-amber-200 text-[#0a2540] hover:bg-amber-50"
                }`}>{c}</button>
            ))}
          </div>
        </div>

        {loading ? (
          <div className="text-center py-20 text-slate-400">लोड हो रहा है...</div>
        ) : filtered.length > 0 ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {filtered.map((b) => <BookCard key={b.id} book={b} />)}
          </div>
        ) : (
          <EmptyState icon="book" message={books.length ? "कोई पुस्तक नहीं मिली।" : "अभी तक कोई पुस्तक नहीं जोड़ी गई है।"} />
        )}
      </section>
    </div>
  );
}
